"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeSlice = exports.storeInitialState = void 0;
const tslib_1 = require("tslib");
const index_1 = require("../../actions/marketplace/getQuerySearch/index");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
exports.storeInitialState = {
    data: [],
    loading: false,
    error: false,
    meta: {},
};
const combineExtraReducers = (builder) => {
    (0, index_1.getQuerySearchExtraReducers)(builder);
};
exports.storeSlice = toolkitRaw.createSlice({
    name: 'search',
    initialState: exports.storeInitialState,
    reducers: {},
    extraReducers: (builder) => {
        return combineExtraReducers(builder);
    },
});
exports.default = exports.storeSlice.reducer;
//# sourceMappingURL=index.js.map